/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ExportReverseRecords$Params {
  organisation_id: string;
  reverse_zone_id: number;
}

export function exportReverseRecords(
  http: HttpClient,
  rootUrl: string,
  params: ExportReverseRecords$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, exportReverseRecords.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("reverse_zone_id", params.reverse_zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "text";
  return http.request(rb.build({ responseType, accept: "text/plain", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    }),
  );
}

exportReverseRecords.PATH = "/surfdomeinen/organisations/{organisation_id}/reverse/{reverse_zone_id}/records/export";
